var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.518 12.556c-.01-1.599.715-2.804 2.177-3.692-.817-1.172-2.055-1.816-3.686-1.94-1.545-.122-3.235.9-3.853.9-.654 0-2.15-.858-3.326-.858-2.428.037-5.009 1.936-5.009 5.798q0 1.713.626 3.534c.558 1.599 2.569 5.515 4.666 5.452 1.097-.026 1.873-.778 3.3-.778 1.386 0 2.103.778 3.326.778 2.117-.03 3.935-3.59 4.465-5.194-2.838-1.338-2.686-3.919-2.686-4m-2.463-7.149c1.188-1.41 1.08-2.695 1.045-3.157-1.05.06-2.264.715-2.955 1.519-.762.862-1.21 1.929-1.114 3.131 1.135.087 2.17-.497 3.024-1.493"
  })));
};
export default SvgApple;